export interface PromoContentProps {
  text1: string; //akcija 2
  text2: string; //akcija 1
  text3: string;
  //icon2: React.ReactNode;
  //icon3: React.ReactNode;
}

export function PromoContent(props: PromoContentProps) {
  const { text1, text2, text3 } = props;

  return (
    <div className="w-full px-4 py-2 gap-[10px] text-[13px] text-gray-extra-dark text-opacity-80">
      {text1 && <div className={"mb-4 font-bold"}>{text1}</div>}
      {text2 && <div className={"flex mb-2 gap-2"}>{text2}</div>}
      {text3 && <div className={"flex mb-2 gap-4"}>{text3}</div>}
    </div>
  );
}
export default PromoContent;
